import { CommonModule } from '@angular/common';
import { SideMenuToastMessagesService } from 'Angular/features/components/toast-messages/side-menu-toast-messages-service';
import { IconModule } from '../../directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/components/toast-messages/side-menu-toast-messages-service";
import * as i2 from "@angular/common";
import * as i3 from "../../directives/icon/icon.directive";
const _forTrack0 = ($index, $item) => $item.id;
function SideMenuToastMessagesComponent_ul_0_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 8);
} if (rf & 2) {
    const message_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(message_r2.icon);
    i0.ɵɵproperty("name", message_r2.icon);
} }
function SideMenuToastMessagesComponent_ul_0_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1)(1, "div", 2);
    i0.ɵɵconditionalCreate(2, SideMenuToastMessagesComponent_ul_0_For_2_Conditional_2_Template, 1, 3, ":svg:svg", 3);
    i0.ɵɵelement(3, "span", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵlistener("click", function SideMenuToastMessagesComponent_ul_0_For_2_Template_div_click_5_listener() { const message_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toastMessageService.removeMessage(message_r2.id)); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", message_r2.css);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(message_r2.icon ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", message_r2.innerHtml, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
function SideMenuToastMessagesComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵrepeaterCreate(1, SideMenuToastMessagesComponent_ul_0_For_2_Template, 8, 4, "li", 1, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r2.containerStyle);
    i0.ɵɵclassMap(ctx_r2.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.toastMessageService.messages);
} }
/**
 * Toast outlet for SideMenuToastMessagesService; rendered inside the side menu so its toasts show
 * on every page that has a side menu.
 */
export class SideMenuToastMessagesComponent {
    constructor(toastMessageService) {
        this.toastMessageService = toastMessageService;
        this.containerClass = 'toast toast-bottom-left flex-column';
        this.containerStyle = 'position: fixed; z-index: 2000';
    }
}
SideMenuToastMessagesComponent.ɵfac = function SideMenuToastMessagesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuToastMessagesComponent)(i0.ɵɵdirectiveInject(i1.SideMenuToastMessagesService)); };
SideMenuToastMessagesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideMenuToastMessagesComponent, selectors: [["ycn-side-menu-toast-messages"]], inputs: { containerClass: "containerClass", containerStyle: "containerStyle" }, decls: 1, vars: 1, consts: [[3, "class", "style", 4, "ngIf"], [1, "ml-auto", "mr-auto", "toast", "toast-context", "width-240", 3, "ngClass"], [1, "toast-text", "width-full"], ["ycnIcon", "", 1, "mr-1", "fill-current", 3, "name", "class"], [3, "innerHTML"], [1, "divider-vertical", "ml-10"], ["data-test-id", "toast-close", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["role", "img", "ycnIcon", "", 1, "icon-close", 3, "name"], ["ycnIcon", "", 1, "mr-1", "fill-current", 3, "name"]], template: function SideMenuToastMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SideMenuToastMessagesComponent_ul_0_Template, 3, 4, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.toastMessageService.messages.length > 0);
    } }, dependencies: [CommonModule, i2.NgClass, i2.NgIf, IconModule, i3.IconDirective], encapsulation: 2 });
